import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import {CssBaseline, Paper} from '@material-ui/core';
import {ThemeProvider} from '@material-ui/core/styles';
import theme from '../../src/theme';

import AOS from 'aos';

import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'leaflet/dist/leaflet.css';
import 'assets/css/index.css';

import 'swiper/swiper-bundle.css';
import 'aos/dist/aos.css';

export default function TopLayout(props) {
    React.useEffect(() => {
        window.CRISP_WEBSITE_ID = "f3bba161-1a40-425c-8966-586d5aab0f1c";
        
        async function createAsyncScript(scriptSrc) {
            const d = document;
            const s = d.createElement("script");
            s.src = scriptSrc;
            s.async = 1;
            d.getElementsByTagName("head")[0].appendChild(s);
        }
        
        async function loadScripts() {
            await createAsyncScript("https://client.crisp.chat/l.js");
            await createAsyncScript("https://www.googletagmanager.com/gtag/js?id=AW-629380240");
            await createAsyncScript("https://www.googletagmanager.com/gtag/js?id=UA-127158128-1");
            
            function gtag() {
                dataLayer.push(arguments);
            }
            
            window.dataLayer = window.dataLayer || [];
            gtag('js', new Date());
            gtag('config', 'AW-629380240');
            gtag('config', 'UA-127158128-1');
        }
        
        loadScripts();
        
    }, []);
    
    React.useEffect(() => {
        // Remove the server-side injected CSS.
        const jssStyles = document.querySelector('#jss-server-side');
        if (jssStyles) {
            jssStyles.parentElement.removeChild(jssStyles);
        }
        
        AOS.init({
            once: true,
            delay: 50,
            duration: 500,
            easing: 'ease-in-out',
        });
    }, []);
    return (
       <React.Fragment>
           <Helmet>
               <title>SaaS Revenue Recognition | ASC 606 Software | SaaS Metrics</title>
               <meta charSet="utf-8"/>
               
               <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width"/>
               <link rel="shortcut icon" href="https://s3.amazonaws.com/content.rev-lock.com/images/favicon.ico"/>
               <meta name="theme-color" content="#ffffff"/>
               <meta name="description"
                     content="REVLOCK is software that automates revenue recognition ASC 606 / IFRS 15 compliance and reporting for software companies, even without an ERP system."/>
               <meta name="robots" content="max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
               <meta property="og:site_name" content="REVLOCK"/>
               <meta property="og:locale" content="en_US"/>
               <meta property="og:type" content="website"/>
               <meta property="og:image"
                     content="https://s3.amazonaws.com/content.rev-lock.com/images/logo.svg"/>
               <meta property="og:title"
                     content="SaaS Revenue Recognition | ASC 606 Software Implementation | Saas Metrics"/>
               <meta property="og:description"
                     content="REVLOCK is software that automates revenue recognition ASC 606 / IFRS 15 compliance and reporting for software companies, even without an ERP system."/>
               <link
                  href="https://fonts.googleapis.com/css?family=Lato:100,100i,300,300i,400,400i,700,700i,900,900i&display=swap"
                  rel="stylesheet"/>
               <script src="https://kit.fontawesome.com/4c273e6d43.js" crossOrigin="anonymous"></script>
           </Helmet>
           <ThemeProvider theme={theme}>
               {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
               <CssBaseline/>
               <Paper elevation={0}>
                   {props.children}
               </Paper>
           </ThemeProvider>
       </React.Fragment>
    );
}

TopLayout.propTypes =
   {
       children: PropTypes.node,
   }
;
